export const VERIFY_TINDER_U_STATUS = 'VERIFY_TINDER_U_STATUS';
export const VERIFY_TINDER_U_STATUS_SUCCESS = 'VERIFY_TINDER_U_STATUS_SUCCESS';
export const VERIFY_TINDER_U_STATUS_ERROR = 'VERIFY_TINDER_U_STATUS_ERROR';
